import namespacedSelector from '../helpers/selectors/namespacedSelector'
const selector = namespacedSelector('sidebar')
export const getActiveUrl = selector('activeUrl')
